(() => {
  if (customElements.get('vindicta-welcome-product')) return;
  customElements.define('vindicta-welcome-product', class extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      this.abortController = new AbortController();
      const update = (price) => {
        const currency = this.dataset.currency;
        const baseCurrency = this.dataset.baseCurrency;
        const rate = currency === 'EUR' ? 1 : (
          baseCurrency === 'EUR' && window.Shopify?.currency?.active === currency
            ? Number(window.Shopify.currency.rate) : NaN
        );
        this.hidden = !(Number.isFinite(rate) && rate > 0 &&
          Number.isFinite(Number(price)) && Number(price) > Math.round(6900 * rate));
      };
      update(this.dataset.price);
      document.addEventListener('variant:change', (event) => {
        if (event.detail?.formId !== this.dataset.formId) return;
        const variant = event.detail.variant;
        if (!variant?.id || (variant.compare_at_price && variant.compare_at_price > variant.price)) {
          this.hidden = true;
          return;
        }
        update(variant.price);
      }, { signal: this.abortController.signal });
    }
    disconnectedCallback() {
      this.abortController?.abort();
    }
  });
})();
(()=>{const dialog=document.getElementById('vindicta-welcome-offer');if(!dialog)return;let opener;document.addEventListener('click',event=>{const trigger=event.target.closest('[data-vw-open]');if(trigger){event.preventDefault();opener=trigger;if(!dialog.open)dialog.showModal();}});dialog.querySelector('[data-vw-close]').addEventListener('click',()=>dialog.close());dialog.addEventListener('click',event=>{if(event.target!==dialog)return;const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();});dialog.addEventListener('close',()=>{if(opener&&opener.isConnected)opener.focus();});dialog.querySelector('[data-vw-copy]').addEventListener('click',async event=>{const button=event.currentTarget;try{await navigator.clipboard.writeText('BIENVENUE10');button.textContent=button.dataset.copied;dialog.querySelector('[data-vw-status]').textContent=button.dataset.copied;}catch{const range=document.createRange();range.selectNodeContents(dialog.querySelector('.vw-code strong'));const selection=window.getSelection();selection.removeAllRanges();selection.addRange(range);}});})();
